export const itemRootPages = [
  {
    path: '/item',
    children: [
      {
        path: ':id',
        component: () => import('@/views/item/TheItemViewPage.vue'),
        name: 'item_view_route',
        props: true
      }
    ]
  }
]
